
<template>
    <b-overlay :show="is_load">
        <div class="categ_info" v-if="item.id > 0">
            <fileload @on_load="on_loading_files" :doc_id="item.id" doc_type="pwa_article"></fileload>
        </div>
    </b-overlay>
</template>

<script>
import Fileload from "../../../../../sys/file_loader/fileload.vue";

export default {
    name: "pwa_article_image",
    components: {
        Fileload
    },
    props : {
        item : {
            type : Object
        }
    },


    data() {
        return {
            is_loaded : false,
            is_load: false,
            my_files : []
        }
    },
    created() {

    },

    methods: {
        on_loading_files(state) {
            this.is_load = state;
        }
    },
}
</script>


<style scoped>

</style>
